(function () {
  const storageKey = 'montillo:favorites';

  function readFavorites() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (_error) {
      return [];
    }
  }

  function writeFavorites(favorites) {
    localStorage.setItem(storageKey, JSON.stringify(favorites));
    window.dispatchEvent(new CustomEvent('montillo:favorites-changed', { detail: { favorites } }));
  }

  function getButtonItem(button) {
    return {
      id: button.dataset.favoriteId,
      title: button.dataset.favoriteTitle || '',
      url: button.dataset.favoriteUrl || '',
      image: button.dataset.favoriteImage || '',
      price: button.dataset.favoritePrice || '',
      artist: button.dataset.favoriteArtist || '',
    };
  }

  function updateButtons(favorites) {
    const ids = new Set(favorites.map((item) => item.id));

    document.querySelectorAll('[data-favorite-button]').forEach((button) => {
      const active = ids.has(button.dataset.favoriteId);
      const label = active
        ? button.dataset.labelRemove || 'Remove from favorites'
        : button.dataset.labelAdd || 'Add to favorites';
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label', label);
    });

    document.querySelectorAll('[data-favorites-count]').forEach((count) => {
      count.textContent = String(favorites.length);
      count.hidden = favorites.length === 0;
    });
  }

  function escapeHTML(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  function favoriteCard(item, removeLabel) {
    const title = escapeHTML(item.title);
    const artist = escapeHTML(item.artist);
    const price = escapeHTML(item.price);
    const url = encodeURI(item.url || '#');
    const image = encodeURI(item.image || '');
    const imageMarkup = item.image
      ? `<img src="${image}" alt="${title}" loading="lazy">`
      : '<div class="favorites-page__placeholder"></div>';

    return `
      <article class="favorites-page__card" data-favorite-card="${escapeHTML(item.id)}">
        <a href="${url}" class="favorites-page__image">${imageMarkup}</a>
        <div class="favorites-page__meta">
          ${artist ? `<span class="favorites-page__artist">${artist}</span>` : ''}
          <a href="${url}" class="favorites-page__title">${title}</a>
          ${price ? `<span class="favorites-page__price">${price}</span>` : ''}
          <button type="button" class="favorites-page__remove" data-favorite-remove="${escapeHTML(item.id)}">${escapeHTML(removeLabel)}</button>
        </div>
      </article>
    `;
  }

  function renderFavoritesPage(favorites) {
    const grid = document.querySelector('[data-favorites-grid]');
    const empty = document.querySelector('[data-favorites-empty]');
    if (!grid || !empty) return;

    const removeLabel = grid.dataset.removeLabel || 'Remove';
    grid.innerHTML = favorites.map((item) => favoriteCard(item, removeLabel)).join('');
    grid.hidden = favorites.length === 0;
    empty.hidden = favorites.length > 0;
  }

  function refresh() {
    const favorites = readFavorites();
    updateButtons(favorites);
    renderFavoritesPage(favorites);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favorite-button]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();

      const item = getButtonItem(button);
      if (!item.id) return;

      const favorites = readFavorites();
      const exists = favorites.some((favorite) => favorite.id === item.id);
      writeFavorites(exists ? favorites.filter((favorite) => favorite.id !== item.id) : [item, ...favorites]);
      return;
    }

    const removeButton = event.target.closest('[data-favorite-remove]');
    if (removeButton) {
      const id = removeButton.dataset.favoriteRemove;
      writeFavorites(readFavorites().filter((favorite) => favorite.id !== id));
    }
  });

  window.addEventListener('montillo:favorites-changed', (event) => {
    refresh(event.detail?.favorites);
  });

  document.addEventListener('DOMContentLoaded', refresh);
})();
